import { Card } from "@/components/ui/card";
import { Trophy } from "lucide-react";

export function CtfReportsList() {
  return (
    <Card className="p-12 text-center">
      <div className="flex flex-col items-center gap-4">
        <div className="h-16 w-16 rounded-full bg-muted flex items-center justify-center">
          <Trophy className="h-8 w-8 text-muted-foreground" />
        </div>
        <div>
          <h3 className="text-lg font-semibold mb-2">CTF Reports</h3>
          <p className="text-sm text-muted-foreground">
            This feature is not yet implemented. CTF reports will be available soon.
          </p>
        </div>
      </div>
    </Card>
  );
}
